<template>
  <div class="Saoyisao">
    <div class="headPic">
      <img src="../assets/images/saoyisao.png" alt="" />
    </div>
    <div class="tishiWord">请点击下载与手机系统相匹配的App</div>

    <div class="downLoadBtn1" @click="downLoadIos">
      <div class="inBtn">
        <div class="btnContent">
          <img src="../assets/images/iphoneIcon.png" alt="" />
          <div class="word1">iOS</div>
          <div class="word2">下载</div>
        </div>
      </div>
    </div>

    <div class="downLoadBtn2" @click="downLoadAndorid">
      <div class="inBtn">
        <div class="btnContent">
          <img src="../assets/images/anzhuoIcon.png" alt="" />
          <div class="word1">Andorid</div>
          <div class="word2">下载</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import { Dialog } from "vant";
import qs from 'qs'
export default {
  mounted() {

    this.getAdUrl();
  },
  data() {
    return {
      AdUrl: null,
      IosUrl:
        "https://apps.apple.com/cn/app/%E6%98%86%E5%B1%B1%E5%B8%82%E6%B0%91%E5%8D%A1-%E6%98%86%E5%B1%B1%E5%B8%82%E6%B0%91%E7%9A%84%E6%9C%AC%E5%9C%B0%E7%94%9F%E6%B4%BB%E6%9C%8D%E5%8A%A1%E5%B9%B3%E5%8F%B0/id1151763857",
    };
  },
  methods: {
    getAdUrl() {
      let params=qs.stringify({
        isH5Web:1
      })
      this.$axios
        .post("/appinteraction/appEdition/getAndroidBean",params)
        .then((res) => {
          console.log(res);
          if (res.data.result != 1) {
            // Dialog.alert({
            //   message: res.data.reason,
            // }).then(() => {});
            return;
          }
          if (res.data.result ==1) {
            console.log(res);
            this.AdUrl = res.data.bean.appUrl;
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    downLoadIos() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        Dialog.alert({
          message: "请点击右上角打开外部浏览器下载。",
        }).then(() => {});
        return;
      }
      if (ua.match(/WeiBo/i) == "weibo") {
        Dialog.alert({
          message: "请点击右上角打开外部浏览器下载。",
        }).then(() => {});
        return;
      }
      if (ua.match(/QQ/i) == "qq") {
        Dialog.alert({
          message: "请点击右上角打开外部浏览器下载。",
        }).then(() => {});
        return;
      }
      window.open(this.IosUrl, "_self");
    },
    downLoadAndorid() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        Dialog.alert({
          message: "请点击右上角打开外部浏览器下载。",
        }).then(() => {});
        return;
      }
      if (ua.match(/WeiBo/i) == "weibo") {
        Dialog.alert({
          message: "请点击右上角打开外部浏览器下载。",
        }).then(() => {});
        return;
      }
      if (ua.match(/QQ/i) == "qq") {
        Dialog.alert({
          message: "请点击右上角打开外部浏览器下载。",
        }).then(() => {});
        return;
      }
      window.open(this.AdUrl, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
.Saoyisao {
  padding: 8.75rem;
  background-color: #ffff;
  min-height: 100vh;
}
.headPic {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 41rem;
  }
}
.tishiWord {
  text-align: center;
  font-size: 1.75rem;
  color: #878787;
  white-space: nowrap;
  margin-top: 4.375rem;
}
.downLoadBtn1 {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;

  .inBtn {
    width: 29.375rem;
    height: 5.5rem;
    background-color: hsl(211deg 100% 49%);
    display: flex;
    align-items: center;
    .btnContent {
      display: flex;
      align-items: center;
      img {
        width: 3.75rem;
        margin-left: 5rem;
      }
      .word1 {
        white-space: nowrap;
        font-size: 2rem;
        margin-left: 3.75rem;
        color: #fff;
      }
      .word2 {
        white-space: nowrap;
        font-size: 2rem;
        margin-left: 1.25rem;
        color: #fff;
      }
    }
  }
}
.downLoadBtn2 {
  display: flex;
  justify-content: center;
  margin-top: 3.75rem;

  .inBtn {
    width: 29.375rem;
    height: 5.5rem;
    background-color: hsl(211deg 100% 49%);
    display: flex;
    align-items: center;
    .btnContent {
      display: flex;
      align-items: center;
      img {
        width: 3.75rem;
        margin-left: 5rem;
      }
      .word1 {
        white-space: nowrap;
        font-size: 2rem;
        margin-left: 1.875rem;
        color: #fff;
      }
      .word2 {
        white-space: nowrap;
        font-size: 2rem;
        margin-left: 1.25rem;
        color: #fff;
      }
    }
  }
}
</style>